<template>
  <div class="apply-page">
    <div class="apply-main">
      <!-- 背景图：复用关于我们模块一的背景（about-1-company.png），absolute 铺满 cover 裁切 -->
      <img class="apply-bg" src="../assets/images/about/about-1-company.png" alt="" />
      <div class="apply-content">
        <!-- 面包屑：热招岗位 > 岗位名，点“热招岗位”返回列表 -->
        <div class="apply-crumb">
          <a href="javascript:;" @click="$router.push('/join')">{{ $t('join.hotJobs') }}</a>
          <span class="crumb-sep">&gt;</span>
          <span>{{ jobTitle }}</span>
        </div>
        <!-- 浅灰表单卡片 -->
        <div class="apply-card">
          <div class="apply-card-head">
            <h2 class="apply-section-title">{{ $t('join.contactTitle') }}</h2>
            <button class="apply-submit" :disabled="submitting" @click="submit">{{ $t('join.submit') }}</button>
          </div>
          <!-- 三列输入：姓名 / 电话 / 邮箱，未填或格式错时字段下方显示红字提示 -->
          <div class="apply-fields">
            <div class="apply-field">
              <label><span class="required">*</span>{{ $t('join.nameLabel') }}</label>
              <input v-model.trim="form.name" type="text" :placeholder="$t('join.namePh')" @blur="validateField('name')" />
              <p v-if="errors.name" class="field-error">{{ errors.name }}</p>
            </div>
            <div class="apply-field">
              <label><span class="required">*</span>{{ $t('join.phoneLabel') }}</label>
              <input v-model.trim="form.phone" type="tel" :placeholder="$t('join.phonePh')" @blur="validateField('phone')" />
              <p v-if="errors.phone" class="field-error">{{ errors.phone }}</p>
            </div>
            <div class="apply-field">
              <label><span class="required">*</span>{{ $t('join.emailLabel') }}</label>
              <input v-model.trim="form.email" type="email" :placeholder="$t('join.emailPh')" @blur="validateField('email')" />
              <p v-if="errors.email" class="field-error">{{ errors.email }}</p>
            </div>
          </div>
          <!-- 上传简历区：点击或拖拽上传，仅 PDF、≤5M -->
          <h3 class="apply-upload-title">{{ $t('join.uploadTitle') }}</h3>
          <div
            class="apply-drop"
            :class="{ 'is-active': dragging }"
            @click="pickFile"
            @dragover.prevent="dragging = true"
            @dragleave="dragging = false"
            @drop.prevent="onDrop"
          >
            <!-- 上传图标：assets/images/about/pdf upload.png（文件名含空格，用 require 引入） -->
            <img class="apply-drop-icon" :src="uploadIcon" alt="" />
            <p class="apply-drop-text">{{ $t('join.uploadTip') }}</p>
            <p class="apply-drop-limit">{{ $t('join.uploadLimit') }}</p>
            <input ref="fileInput" type="file" accept="application/pdf,.pdf" hidden @change="onFileChange" />
          </div>
          <p v-if="file" class="apply-file-info">📄 {{ file.name }}</p>
          <p v-if="errors.file" class="field-error">{{ errors.file }}</p>
        </div>
      </div>
    </div>
    <Footer />
    <!-- 投递成功弹窗：点“好的”关闭并返回热招岗位列表 -->
    <div v-if="showSuccess" class="success-mask">
      <div class="success-dialog">
        <!-- 投递成功图标：assets/images/about/join us.png（文件名含空格，用 require 引入） -->
        <div class="success-art">
          <img class="success-icon" :src="successIcon" alt="" />
        </div>
        <h3 class="success-title">{{ $t('join.successTitle') }}</h3>
        <p class="success-desc">{{ $t('join.successDesc') }}</p>
        <button class="success-btn" @click="onSuccessOk">{{ $t('join.successOk') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'JobApplyPage',
  components: { Footer },
  data() {
    return {
      // 当前为演示模式：校验通过直接弹成功窗，不发邮件。
      // 后端 /admin/join 已就绪（join-server，SMTP 已验证）；正式部署上线后改为 true 即走真实提交发信
      apiReady: true,
      form: { name: '', phone: '', email: '' },
      errors: { name: '', phone: '', email: '', file: '' },
      file: null,
      dragging: false,
      submitting: false,
      showSuccess: false,
      // 投递成功弹窗图标（文件名含空格，用 require 引入更稳妥）
      successIcon: require('@/assets/images/about/join us.png'),
      // 上传简历区图标（同上，文件名含空格）
      uploadIcon: require('@/assets/images/about/pdf upload.png')
    }
  },
  computed: {
    jobId() {
      return this.$route.query.job || 'register'
    },
    jobTitle() {
      return this.$t('join.jobs.' + this.jobId)
    }
  },
  methods: {
    validateField(field) {
      this.errors[field] = ''
      if (field === 'name') {
        if (!this.form.name) this.errors.name = this.$t('join.errName')
      } else if (field === 'phone') {
        if (!this.form.phone) {
          this.errors.phone = this.$t('join.errPhone')
        } else if (!/^[+\d][\d\s-]{5,19}$/.test(this.form.phone)) {
          this.errors.phone = this.$t('join.errPhoneFormat')
        }
      } else if (field === 'email') {
        if (!this.form.email) {
          this.errors.email = this.$t('join.errEmail')
        } else if (!/^[\w.-]+@[\w-]+(\.[\w-]+)+$/.test(this.form.email)) {
          this.errors.email = this.$t('join.errEmailFormat')
        }
      }
      return !this.errors[field]
    },
    validateFile() {
      this.errors.file = ''
      if (!this.file) {
        this.errors.file = this.$t('join.errFile')
        return false
      }
      return true
    },
    validate() {
      const okName = this.validateField('name')
      const okPhone = this.validateField('phone')
      const okEmail = this.validateField('email')
      const okFile = this.validateFile()
      return okName && okPhone && okEmail && okFile
    },
    pickFile() {
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      this.checkFile(e.target.files[0])
      e.target.value = ''
    },
    onDrop(e) {
      this.dragging = false
      this.checkFile(e.dataTransfer.files[0])
    },
    // 文件校验：仅 PDF 且 ≤5M
    checkFile(file) {
      this.errors.file = ''
      if (!file) return
      const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name)
      if (!isPdf) {
        this.file = null
        this.errors.file = this.$t('join.errFileType')
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        this.file = null
        this.errors.file = this.$t('join.errFileSize')
        return
      }
      this.file = file
    },
    submit() {
      if (!this.validate()) return
      if (!this.apiReady) {
        this.showSuccess = true
        return
      }
      const data = new FormData()
      data.append('job', this.jobId)
      // 岗位中文名随表单一并提交，后端邮件标题/正文用它展示（代替岗位 ID）
      data.append('jobTitle', this.jobTitle)
      data.append('name', this.form.name)
      data.append('phone', this.form.phone)
      data.append('email', this.form.email)
      data.append('resume', this.file)
      this.submitting = true
      fetch('/admin/join', { method: 'POST', body: data })
        .then((res) => {
          if (!res.ok) throw new Error()
          this.showSuccess = true
          this.form = { name: '', phone: '', email: '' }
          this.file = null
        })
        .catch(() => {
          this.errors.file = this.$t('join.errServer')
        })
        .finally(() => {
          this.submitting = false
        })
    },
    // 点“好的”：关弹窗并返回热招岗位列表
    onSuccessOk() {
      this.showSuccess = false
      this.$router.push('/join')
    }
  }
}
</script>

<style scoped>
/* 页面容器：顶部预留导航栏高度 */
.apply-page {
  padding-top: 80px;
}

/* 页面主体：背景图定位基准 */
.apply-main {
  position: relative;
  min-height: calc(100vh - 80px);
}

/* 背景图：与关于我们模块一一致，铺满主体区域、cover 裁切 */
.apply-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

/* 内容区：居中限宽，上下内边距调顶部留白和底部间距 */
.apply-content {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  margin: 0 auto;
  padding: 74px 40px 140px;
}

/* 面包屑：改 font-size 调大小，改 margin-bottom 调与下方卡片间距 */
.apply-crumb {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  margin-bottom: 50px;
}

/* 面包屑链接：文字半透明白，下划线独立纯白不透明，改 width 调下划线长度，改 bottom 调下划线与文字间距 */
.apply-crumb a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  position: relative;
  font-weight: 400;
}

.apply-crumb a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 75%;
  height: 2px;
  background: #FFFFFF;
}

/* hover 时不增加额外下划线 */
.apply-crumb a:hover {
  text-decoration: none;
}

/* 面包屑分隔符间距 */
.crumb-sep {
  margin: 0 12px;
}

/* 浅灰表单卡片（改 padding 调内边距；背景透明度改 rgba 末尾数字 0~1，越小越透） */
.apply-card {
  background: rgba(245, 245, 245, 0.5);
  border-radius: 14px;
  padding: 44px 60px 56px;
}

/* 卡片头部：标题与提交按钮横向排列 */
.apply-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

/* 卡片内标题"联系方式" */
.apply-section-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #252525;
  margin: 0;
}

/* 提交按钮：卡片右上角 */
.apply-submit {
  background: #00ADBB;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 10px 44px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.apply-submit:hover {
  background: #00C4D4;
}

.apply-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 三列输入区 */
.apply-fields {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
}

/* 单个输入字段容器 */
.apply-field {
  display: flex;
  flex-direction: column;
}

.apply-field label {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #252525;
  margin-bottom: 10px;
}

.apply-field .required {
  color: #E53935;
  margin-right: 4px;
}

/* 输入框：（改 border-bottom 调横线颜色/粗细） */
.apply-field input {
  border: none;
  border-bottom: 1px solid #000000;
  border-radius: 0;
  background: transparent;
  outline: none;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 15px;
  color: #252525;
  padding: 11px 14px;
  transition: border-color 0.3s ease;
}

.apply-field input::placeholder {
  color: #6C6C6C;
}

/* 字段下方红字错误提示 */
.field-error {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 13px;
  color: #E53935;
  margin: 8px 0 0 0;
}

/* 上传简历标题 */
.apply-upload-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #252525;
  margin: 40px 0 16px 0;
}

/* 上传区：实线框，点击或拖拽上传（边框颜色/粗细改 border） */
.apply-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 230px;
  background: transparent;
  border: 1px solid #000000;
  border-radius: 10px;
  cursor: pointer;
}

/* 上传区图标：尺寸在这里独立控制（改 width 调大小） */
.apply-drop-icon {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

/* 上传提示文字 */
.apply-drop-text {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 16px;
  color: #252525;
  margin: 14px 0 6px 0;
}

/* 上传限制说明（PDF、≤5M） */
.apply-drop-limit {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 14px;
  color: #252525;
  margin: 0;
}

/* 已选文件名 */
.apply-file-info {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 15px;
  color: #252525;
  margin: 16px 0 0 0;
}

/* 投递成功弹窗遮罩 */
.success-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-dialog {
  width: 560px;
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);
  padding: 48px 60px 44px;
  text-align: center;
}

/* 弹窗内图标容器 */
.success-art {
  margin-bottom: 8px;
}

/* 投递成功图标：改 width 调图标显示大小 */
.success-icon {
  width: 160px;
  height: auto;
  display: inline-block;
}

/* 弹窗标题"投递成功" */
.success-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 16px 0;
}

/* 说明文字：连续文本自然换行 */
.success-desc {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 15px;
  color: #8C8C8C;
  line-height: 1.8;
  margin: 0 0 30px 0;
}

/* 弹窗"好的"按钮 */
.success-btn {
  background: #00ADBB;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  width: 240px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 17px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.success-btn:hover {
  background: #00C4D4;
}





/* ============================================================
 * 移动端适配（<= 1024px）
 * ============================================================ */
@media (max-width: 1024px) {
  /* 页面容器：不设顶部留白，让背景图铺满视口 */
  .apply-page {
    padding-top: 0;
  }

  /* 主内容区：铺满整屏，背景图覆盖整个区域 */
  .apply-main {
    min-height: 100vh;
  }

  /* 内容内边距：顶部预留导航栏高度，内容从导航栏下方开始 */
  .apply-content {
    padding: 14vh 6% 10vh;
  }

  /* 面包屑 */
  .apply-crumb {
    font-size: 5.6vw;
    margin-bottom: 4vh;
  }

  /* 面包屑分隔符 */
  .crumb-sep {
    margin: 0 2vw;
  }

  /* 表单卡片 */
  .apply-card {
    padding: 4vh 5vw 5vh;
    border-radius: 3vw;
  }

  /* 卡片头部：标题与按钮同行，两端对齐 */
  .apply-card-head {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3vh;
  }

  /* 卡片内标题字号 */
  .apply-section-title {
    font-size: 5.6vw;
  }

  /* 提交按钮：字号缩小 */
  .apply-submit {
    padding: 1vh 6vw;
    font-size: 4.27vw;
  }

  /* 三列输入改单列 */
  .apply-fields {
    grid-template-columns: 1fr;
    gap: 3vh;
  }

  /* 字段标签字号 */
  .apply-field label {
    font-size: 4vw;
    margin-bottom: 0vh;
  }

  /* 输入框字号与内边距 */
  .apply-field input {
    font-size: 3.8vw;
    padding: 1vh 3vw;
  }

  /* 错误提示字号 */
  .field-error {
    font-size: 3.5vw;
    margin: 1vh 0 0 0;
  }

  /* 上传区 */
  .apply-upload-title {
    font-size: 5vw;
    margin: 4vh 0 2vh 0;
  }

  /* 上传区高度与圆角 */
  .apply-drop {
    height: 28vh;
    border-radius: 2vw;
  }

  /* 上传图标大小 */
  .apply-drop-icon {
    width: 8vh;
    height: 8vh;
  }

  /* 上传提示文字 */
  .apply-drop-text {
    font-size: 4.27vw;
    margin: 2vh 0 1vh 0;
    text-align: center;
  }

  /* 上传限制说明 */
  .apply-drop-limit {
    font-size: 3.73vw;
  }

  /* 已选文件名 */
  .apply-file-info {
    font-size: 3.8vw;
    margin: 2vh 0 0 0;
  }

  /* 成功弹窗 */
  .success-dialog {
    width: 88%;
    padding: 5vh 6% 5vh;
    border-radius: 4vw;
  }

  /* 弹窗成功图标 */
  .success-icon {
    width: 22vh;
  }

  /* 弹窗标题 */
  .success-title {
    font-size: 6vw;
    margin: 0 0 2vh 0;
  }

  /* 弹窗说明文字 */
  .success-desc {
    font-size: 4vw;
    margin: 0 0 3vh 0;
  }

  /* 弹窗确认按钮 */
  .success-btn {
    width: 70%;
    font-size: 4.5vw;
  }
}
</style>
